import React, {
  useState,
  useContext,
  lazy,
  Suspense,
  useCallback,
} from "react";
import { NavLink } from "react-router-dom";
import { UserContext } from "../../App";
import "./navbar.css";

const NavLinkWithLazyLoad = lazy(() =>
  import("react-router-dom").then((module) => ({ default: module.NavLink }))
);

const Navbar = React.memo(() => {
  const [activeLink, setActiveLink] = useState("/");
  const TheUserContext = useContext(UserContext);
  const setDisplayHomePage = TheUserContext.setDisplayHomePage;
  const {sidebarIsOpen, setSidebarIsOpen} = TheUserContext;

  const handleHomeLinkClick = useCallback(
    (path) => {
      setDisplayHomePage(true);
      setActiveLink(path);
      setSidebarIsOpen(false);
    },
    [setDisplayHomePage, setSidebarIsOpen]
  );

  const handleLinkClick = useCallback(
    (path) => {
      setDisplayHomePage(false);
      setActiveLink(path);
      setSidebarIsOpen(false);
    },
    [setDisplayHomePage, setSidebarIsOpen]
  );

  return (
    <nav
      className='Navbar'
    >
      <span className="nav-logo">DreamHome</span>

      <div className={`nav-items ${sidebarIsOpen && "open"}`}>
        <Suspense fallback={<div>Loading...</div>}>
          <NavLinkWithLazyLoad
            to="/"
            onClick={() => handleHomeLinkClick("/")}
            className={activeLink === "/" ? "activated" : ""}
            alt="home section"
          >
            Home
          </NavLinkWithLazyLoad>
          <NavLinkWithLazyLoad
            to="/about"
            onClick={() => handleLinkClick("/about")}
            className={`capitlize__txt ${activeLink === "/about" ? "activated" : ""}`}
            alt="about section"
          >
            About us
          </NavLinkWithLazyLoad>
          <NavLinkWithLazyLoad
            to="/service"
            onClick={() => handleLinkClick("/service")}
            className={activeLink === "/service" ? "activated" : ""}
            alt="service section"
          >
            Service
          </NavLinkWithLazyLoad>
          <NavLinkWithLazyLoad
            to="/contact"
            onClick={() => handleLinkClick("/contact")}
            className={activeLink === "/contact" ? "activated" : ""}
            alt="contact section"
          >
            Contact
          </NavLinkWithLazyLoad>
        </Suspense>
      </div>

      <div className={`log_sign ${!sidebarIsOpen && "open"}`}>
        <NavLink
          to="/login"
          className="log"
          onClick={() => handleLinkClick("/login")}
          alt="log in section"
        >
          Log In
        </NavLink>
        <NavLink
          to="/register"
          className="sign"
          onClick={() => handleLinkClick("/register")}
          alt="register section"
        >
          Register
        </NavLink>
      </div>

      <div
        className={`nav-toggle ${sidebarIsOpen && "open"}`}
        onClick={() => setSidebarIsOpen(!sidebarIsOpen)}
      >
        <div className="bar"></div>
      </div>
    </nav>
  );
});

export default Navbar;
